const accordions = document.querySelectorAll( '.wp-block-create-block-docomo-accordion' );

function openPanel( panel, trigger ) {
	panel.classList.add( 'is-open' );
	const targetHeight = panel.scrollHeight;
	panel.style.height = '0';
	panel.offsetHeight; // force reflow
	panel.style.height = targetHeight + 'px';
	trigger.setAttribute( 'aria-expanded', 'true' );

	panel.addEventListener( 'transitionend', function onOpen( e ) {
		if ( e.propertyName !== 'height' ) return;
		panel.removeEventListener( 'transitionend', onOpen );
		if ( panel.classList.contains( 'is-open' ) ) {
			panel.style.height = 'auto';
		}
	} );
}

function closePanel( panel, trigger ) {
	panel.style.height = panel.scrollHeight + 'px';
	trigger.setAttribute( 'aria-expanded', 'false' );
	panel.offsetHeight; // force reflow

	// Animate height and padding to 0 simultaneously
	panel.style.height = '0';
	panel.classList.remove( 'is-open' );
}

accordions.forEach( ( accordion ) => {
	const items = Array.from( accordion.children ).filter( ( element ) =>
		element.classList.contains( 'docomo-accordion-item' )
	);
	if ( ! items.length ) {
		return;
	}

	items.forEach( ( item ) => {
		const panel = item.querySelector( '.docomo-accordion-panel' );
		const trigger = item.querySelector( '.docomo-accordion-trigger' );
		if ( ! panel || ! trigger ) {
			return;
		}
		panel.classList.remove( 'is-open' );
		panel.style.height = '0';
		trigger.setAttribute( 'aria-expanded', 'false' );
	} );

	accordion.addEventListener( 'click', ( event ) => {
		const trigger = event.target.closest( '.docomo-accordion-trigger' );
		if ( ! trigger ) {
			return;
		}
		const ownerAccordion = trigger.closest( '.wp-block-create-block-docomo-accordion' );
		if ( ownerAccordion !== accordion ) {
			return;
		}
		const currentItem = trigger.closest( '.docomo-accordion-item' );
		if ( ! currentItem || currentItem.parentElement !== accordion ) {
			return;
		}
		const currentPanel = currentItem?.querySelector( '.docomo-accordion-panel' );
		if ( ! currentItem || ! currentPanel ) {
			return;
		}

		if ( currentPanel.classList.contains( 'is-open' ) ) {
			closePanel( currentPanel, trigger );
		} else {
			openPanel( currentPanel, trigger );
		}
	} );
} );
